import { useRef } from "react";
import Select, { SelectProps } from "..";
import { ILodGrp } from "interface/index";
import { useQuery } from "@tanstack/react-query";
import { lodGrpListApi } from "components/api/member";
import useAuthStore from "store/auth";

interface IProps extends Omit<SelectProps, "options"> {
  isFullInf?: boolean;
  select?(inf: any): void;
}

export default function LodGrpNo({
  isFullInf = false,
  select,
  defaultValue,
  required,
  isReset,
}: IProps) {
  const isLogin = useAuthStore((state) => state.isLogin);
  const lodGrpRef = useRef<ILodGrp[]>([]);

  useQuery({
    queryKey: ["lodGrpList"],
    queryFn: lodGrpListApi,
    select: (res) => {
      lodGrpRef.current = res.data.lodGrpList.map((lodGrp: ILodGrp) => {
        return {
          ko: lodGrp.lodGrpNm,
          en: lodGrp.lodGrpNm,
          code: lodGrp.lodGrpNo,
          value: lodGrp.lodGrpNo,
          ...lodGrp,
        };
      });
    },
    // enabled: isLogin,
  });
  return (
    <Select
      options={lodGrpRef.current}
      defaultValue={defaultValue}
      dataTyp={"C"}
      name={"rmNo"}
      required={required}
      isReset={isReset}
      styles=""
      validateTxt="숙소그룹을 선택하여 주세요."
      onSelect={(option) => {
        if (select) {
          isFullInf ? select(option) : select(option?.lodGrpNo);
        }
      }}
    />
  );
}
